import { createContext } from 'react'

export const UTXOExternalContext = createContext<boolean>(false)
